// extracted by mini-css-extract-plugin
export var header = "index-module--header--fbfbf";
export var inner = "index-module--inner--6b93c";
export var item = "index-module--item--ae688";
export var link = "index-module--link--7a7ee";
export var linkLabel = "index-module--linkLabel--850a3";